import api from './api';

export const getBuildingsApi = params => {
  return api.get('/buildings', {params});
};

export const getAllBuildingsApi = params => {
  return api.get('/buildings/all', {params});
};

export const getBuildingDetailsApi = id => {
  return api.get(`/buildings/${id}`);
};

export const addBuildingApi = params => {
  return api.post('/buildings', params);
};

export const editBuildingApi = params => {
  return api.put('/buildings', params);
};

export const deleteBuildingApi = id => {
  return api.delete(`/buildings/${id}`);
};

export const getBuldingsGraphApi = () => {
  return api.get('/buildings/graph');
};
